import { Injectable, inject } from "@angular/core";
import { PublicContact } from "../interfaces/public-contact";
import { GlobalScripts } from "../interfaces/global-scripts";
import { MITPService } from "./mitp.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: "root",
})
export class AdminService {
	private httpClient = inject(HttpClient);
	private mitp = inject(MITPService);

	getPublicContacts() {
		return this.httpClient.get<PublicContact[]>(this.mitp.Contact());
	}

	switchAccount(userId: number) {
		return this.httpClient.put(this.mitp.Users() + `/switch/${userId}`, null);
	}

	getServerStatus() {
		return this.httpClient.get(this.mitp.Server());
	}

	getGlobalScripts() {
		return this.httpClient.get<GlobalScripts>(this.mitp.Protocols() + "/admin/scripts");
	}

	updateGlobalScripts(scripts: GlobalScripts) {
		return this.httpClient.put(this.mitp.Protocols() + "/admin/scripts", scripts, { observe: "response" });
	}

	resetGlobalScripts() {
		return this.httpClient.post(this.mitp.Protocols() + "/admin/scripts", null, { observe: "response" });
	}

	getProtocolCss() {
		return this.httpClient.get(this.mitp.PublicResources() + "/protocols/css", { responseType: "text" });
	}

	getProtocolJs() {
		return this.httpClient.get(this.mitp.PublicResources() + "/protocols/js", { responseType: "text" });
	}
}
